<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ct"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chiZabinski0009#intro"><span class="sm">INTRODUCTION</span>   A Biography of Wheat?</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0010#ch01"><span class="sm">CHAPTER</span> <span class="sm">ONE</span>   The Whispering of the Grasses</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0011#ch02"><span class="sm">CHAPTER</span> <span class="sm">TWO</span>   The First Encounter</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0012#ch03"><span class="sm">CHAPTER</span> <span class="sm">THREE</span>   Intertwined Lives</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0013#ch04"><span class="sm">CHAPTER</span> <span class="sm">FOUR</span>   From Villages to Cities</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0014#ch05"><span class="sm">CHAPTER</span> <span class="sm">FIVE</span>   Relationships Are Hard Work</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0015#ch06"><span class="sm">CHAPTER</span> <span class="sm">SIX</span>   Nurture and Nature</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0016#ch07"><span class="sm">CHAPTER</span> <span class="sm">SEVEN</span>   War and Peace and Wheat</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0017#ch08"><span class="sm">CHAPTER</span> <span class="sm">EIGHT</span>   Order in Chaos</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0018#ch09"><span class="sm">CHAPTER</span> <span class="sm">NINE</span>   A Love-Hate Relationship</a></p>
<p class="toc"><a class="xref" href="#/chiZabinski0019#epil"><span class="sm">EPILOGUE</span>   An Eternal Harvest</a></p>
<p class="tocbmf"><a class="xref" href="#/chiZabinski0020#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiZabinski0021#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiZabinski0022#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chiZabinski0023#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Zabinski-0006.vue?79ecffc1